import * as dynameatApi from '@dynameat/api';
import { SET_LOADING } from '@dynameat/mutationTypes';
import { sectionRequest } from '@menu/views/MenuEditor/api';
import { Section } from '@menu/views/MenuEditor/models';
import { MenuGridConfiguration, MenuGridItem, MenuGridItemConfiguration } from '../models';
import * as api from '../api';
import * as MutationTypes from './mutationTypes';

export const selectedMenu = async ({ commit, dispatch }, menu) => {
  const menuGridConfigurationGuid = menu.grid_configuration;
  const response = await api.menuGridConfigurationRequest(menuGridConfigurationGuid);
  const menuGridConfiguration = MenuGridConfiguration.toInstance(response.data);
  commit(MutationTypes.SELECT_MENU_FOR_GRID, menu);
  commit(MutationTypes.SELECT_COL, menuGridConfiguration.column);
  commit(MutationTypes.SELECT_ROW, menuGridConfiguration.row);
  commit(MutationTypes.SELECT_GRID_TEMPLATE_AREA, menuGridConfiguration.gridTemplateArea);
  commit(MutationTypes.SELECT_IMAGE, menuGridConfiguration.backgroundImage ? new File([], 'Previous File ') : null);
  commit(MutationTypes.SELECT_PADDING_GRID, menuGridConfiguration.padding);
  commit(MutationTypes.GRID_CONFIGURATION, menuGridConfiguration);
  commit(MutationTypes.SELECT_ASPECT_RATIO, menuGridConfiguration.aspectRatio);
  // SELECT_BACKGROUND_IMAGE_ASPECT_RATIO
  commit(MutationTypes.SELECT_BACKGROUND_IMAGE_SIZE_BEHAVIOUR, menuGridConfiguration.backgroundImageSizeBehaviour);
  dispatch('menuGridItemListRequest');
};

export const menuGridItemListRequest = async ({ commit, getters: { gridConfiguration } }) => {
  const response = await api.menuGridItemRequest('', gridConfiguration.guid);
  const menuGridItemList = MenuGridItem.toInstanceList(response.data.results);
  commit(MutationTypes.SELECT_MENU_GRID_ITEM_LIST, menuGridItemList);
};

export const menuGridItemConfigurationRequest = async ({ commit }, menuGridItemConfigurationGuid) => {
  const response = await api.gridItemConfigurationRequest(menuGridItemConfigurationGuid);
  const gridItemConfiguration = MenuGridItemConfiguration.toInstance(response.data);
  commit(MutationTypes.SELECT_MENU_GRID_ITEM_CONFIGURATION, gridItemConfiguration);
};

export const updateGridItemConfigurationRequest = async ({ getters: { selectedGridItemConfiguration } }) => {
  await api.updateGridItemConfigurationRequest(selectedGridItemConfiguration.guid, selectedGridItemConfiguration.serialize());
};

export const clausesRequest = async ({ commit, getters: { selectedMenuForGrid } }) => {
  const response = await sectionRequest('', selectedMenuForGrid.guid, 1);
  const clausesList = Section.toInstanceList(response.data.results);
  commit(MutationTypes.SELECT_CLAUSE_LIST, clausesList);
};

export const createMenuGridItem = async (_, menuGridItem) => {
  await api.createGridItemRequest(menuGridItem.getFormData());
};

export const editMenuGridItem = async (_, menuGridItem) => {
  await api.updateGridItemRequest(menuGridItem.guid, menuGridItem.getFormData());
};

export const deleteMenuGridItem = async ({ dispatch }, menuGridItem) => {
  await api.deleteGridItemRequest(menuGridItem.guid);
  dispatch('gridItemToDelete', menuGridItem);
};

export const gridItemToDelete = async ({ commit }, gridItem) => {
  commit(MutationTypes.GRID_ITEM_TO_DELETE, gridItem);
};

export const selectCol = ({ commit }, col) => {
  commit(MutationTypes.SELECT_COL, col);
};

export const selectRow = ({ commit }, row) => {
  commit(MutationTypes.SELECT_ROW, row);
};

export const selectImage = ({ commit }, image) => {
  commit(MutationTypes.SELECT_IMAGE, image);
};

export const selectPaddingGrid = ({ commit }, paddingGrid) => {
  commit(MutationTypes.SELECT_PADDING_GRID, paddingGrid);
};

export const selectGridItem = ({ commit }, gridItem) => {
  commit(MutationTypes.SELECT_GRID_ITEM, gridItem);
};

export const selectGridItemConfigurationToNull = ({ commit }) => {
  commit(MutationTypes.SELECT_MENU_GRID_ITEM_CONFIGURATION, null);
};

export const selectGridTemplateArea = ({ commit }, template) => {
  commit(MutationTypes.SELECT_GRID_TEMPLATE_AREA, template);
};

export const selectAspectRatio = ({ commit }, aspectRatio) => {
  commit(MutationTypes.SELECT_ASPECT_RATIO, aspectRatio);
};

export const selectBackgroundImageSizeBehaviour = ({ commit }, backgroundImageSizeBehaviour) => {
  commit(MutationTypes.SELECT_BACKGROUND_IMAGE_SIZE_BEHAVIOUR, backgroundImageSizeBehaviour);
};

export const updateMenuGridItemConfiguration = ({ commit }, gridItemConfigurationForm) => {
  commit(MutationTypes.UPDATE_MENU_GRID_ITEM_CONFIGURATION, gridItemConfigurationForm);
};

export const updateMenuGridConfiguration = async ({
  commit, getters: {
    col,
    row,
    gridTemplateArea,
    gridConfiguration,
    paddingGrid,
    image,
    aspectRatio,
    backgroundImageSizeBehaviour
  }, dispatch
}) => {
  const menuGridConfig = MenuGridConfiguration.toInstance(gridConfiguration.serialize());
  menuGridConfig.column = col;
  menuGridConfig.row = row;
  menuGridConfig.gridTemplateArea = gridTemplateArea;
  menuGridConfig.padding = paddingGrid;
  menuGridConfig.backgroundImage = image;
  menuGridConfig.aspectRatio = aspectRatio;
  menuGridConfig.backgroundImageSizeBehaviour = backgroundImageSizeBehaviour;
  const response = await api.updateMenuGridConfigurationRequest(menuGridConfig.guid, menuGridConfig.getFormData());
  await dispatch('preview');
  const updatedMenuGrid = MenuGridConfiguration.toInstance(response.data);
  commit(MutationTypes.UPDATE_MENU_GRID_CONFIGURATION_SUCCESS, updatedMenuGrid);
};

export const clear = ({ commit }) => {
  commit(MutationTypes.SELECT_MENU_FOR_GRID, null);
  commit(MutationTypes.GRID_CONFIGURATION, null);
  commit(MutationTypes.SELECT_GRID_ITEM, null);
  commit(MutationTypes.SELECT_MENU_GRID_ITEM_CONFIGURATION, null);
  commit(MutationTypes.SELECT_GRID_TEMPLATE_AREA, '');
  commit(MutationTypes.SELECT_CACHE, null);
  commit(MutationTypes.SELECT_IMAGE, null);
  commit(MutationTypes.SET_OPEN_PORTAL, false);
};

export const setOpenPortal = ({ commit }, openPortal) => {
  commit(MutationTypes.SET_OPEN_PORTAL, openPortal);
};

export const preview = async ({ commit, getters: { selectedMenuForGrid, serviceList } }) => {
  commit(MutationTypes.SELECT_CACHE, null);
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const saleZoneGuid = selectedMenuForGrid.sale_zones[0];
  commit(SET_LOADING, 1);
  const cache = (await dynameatApi.menuGridPreviewCacheRequest(selectedMenuForGrid.guid, saleZoneGuid, serviceList[0].guid, year, month, day)).data;
  cache.selectedZone = saleZoneGuid;
  cache.prices_cache = { [cache.selectedZone]: cache.prices_cache };
  commit(MutationTypes.SELECT_CACHE, cache);
  commit(SET_LOADING, -1);
};
